import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingSpinner from "../components/LoadingSpinner";
import EditorLoginGate from "../components/EditorLoginGate";
import apiClient from "../api/apiClient";
import StudioWorkspace from "../mockup-studio/StudioWorkspace";
import ShowMoreButtonStatic from "./ShowMoreButtonStatic";
import MockupCard from "../components/MockupCard";

/** /shared/mockup-editor?link=…: a seller's shared mockup in the editor. */
const SharedMockupEditor = () => {
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const isAdmin = role === "A";
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [mockupData, setMockupData] = useState({});

  const getCurrentURLParameters = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams) {
      params[key] = value;
    }
    return params;
  };

  const { link } = getCurrentURLParameters();
  const fetchMockup = async () => {
    setLoader(true);
    const result = await apiClient.get(
      `/listings/shared-mockup/?sharable_link_id=${link}`
    );
    setLoader(false);
    if (!result.ok) return;
    setMockupData(result?.data);

  };

  const handlenNavigateSearchpage = (key, value, title, heading) => {
    navigate(`/Searchpage?${key}=${value}`, { state: { des: title, heading } });
  };

  useEffect(() => {
    if (!link || (!isLoggedIn && !isAdmin)) return;
    fetchMockup();
  }, [link, isLoggedIn, isAdmin]);

  if (!isLoggedIn && !isAdmin) {
    return <EditorLoginGate />;
  }

  return (
    <>
      {!loader ? (
        <>
          {!mockupData?.is_seller_pro_active ||
          !mockupData?.sharable_link_enabled ? (
            <div
              style={{
                display: "flex",
                height: "100vh",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f9f9f9",
                padding: "2rem",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "2rem 3rem",
                  borderRadius: "12px",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                  maxWidth: "400px",
                  width: "100%",
                }}
              >
                <h2
                  style={{
                    color: "#d32f2f",
                    fontSize: "1.8rem",
                    marginBottom: "1rem",
                  }}
                >
                  Access Denied
                </h2>
                <p style={{ color: "#555", fontSize: "1rem" }}>
                  You are not authorized to perform this action. Please contact
                  the administrator if you believe this is an error. Or Login to
                  continue
                </p>
              </div>
            </div>
          ) : (
            <div className="mockup">
              <StudioWorkspace key={mockupData.id} initialListing={mockupData} shared />
              <div className="container-lg">
                <div className="w-full d-flex align-items-center justify-content-center mt-4">
                  <p
                    style={{
                      fontSize: "clamp(22px, 5vw, 42px)",
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    Browse
                    <span
                      style={{
                        color: "#c93312",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src={"../assets/images/justLogo.svg"}
                        style={{ width: "42px", height: "auto" }}
                        alt="logo of sitemark"
                      />
                      Mockee
                    </span>
                    for more mockups
                  </p>
                </div>
                {mockupData?.same_category_listings?.length > 0 && (
                  <section className="mt-4 mb-6">
                    <div
                      className="container py-3"
                      style={{
                        backgroundColor: "#E3EBE0",
                        borderRadius: "20px",
                      }}
                    >
                      <h2 className="text-start fw-bold mb-1">
                        Similar Mockups
                      </h2>
                      <p className="text-start mb-1">Browse similar mockups.</p>

                      <div className="row">
                        {mockupData?.same_category_listings?.map(
                          (item, index) => (
                            <MockupCard
                              key={index}
                              imageUrl={
                                item?.use_main_file_as_thumbnail
                                  ? item?.compressed_file
                                  : item?.thumbnails?.[0]?.image
                              }
                              title={item.title}
                              description={item.short_description}
                              price={item.price}
                              seller={item.user_name}
                              id={item.id}
                              item={item}
                              col={3}
                            />
                          )
                        )}
                      </div>
                      <div className="flex mt-2">
                        <ShowMoreButtonStatic
                          onClick={() =>
                            handlenNavigateSearchpage(
                              "subcategory",
                              mockupData?.subcategory,
                              "Browse Mockups from same sub category.",
                              "Similar Mockups"
                            )
                          }
                        />
                      </div>
                    </div>
                  </section>
                )}
                {mockupData?.same_creator_listings?.length > 0 && (
                  <section className="mb-4 mt-2">
                    <div
                      className="container py-3"
                      style={{
                        backgroundColor: "#FDF9EE",
                        borderRadius: "20px",
                      }}
                    >
                      <h2 className="text-start fw-bold mb-1">
                        More from this seller
                      </h2>
                      <p className="text-start mb-1">
                        Browse this seller mockups.
                      </p>

                      <div className="row">
                        {mockupData?.same_creator_listings?.map(
                          (item, index) => (
                            <MockupCard
                              key={index}
                              imageUrl={
                                item?.use_main_file_as_thumbnail
                                  ? item?.compressed_file
                                  : item?.thumbnails?.[0]?.image
                              }
                              title={item.title}
                              description={item.short_description}
                              price={item.price}
                              seller={item.user_name}
                              id={item.id}
                              item={item}
                              col={3}
                            />
                          )
                        )}
                      </div>

                      <div className="flex mt-2">
                        <ShowMoreButtonStatic
                          onClick={() =>
                            navigate(
                              `/browse-mockups?name=${mockupData?.user_id}`
                            )
                          }
                        />
                      </div>
                    </div>
                  </section>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="d-flex justify-content-center mt-5">
          <LoadingSpinner color="#FF3E1F" />
        </div>
      )}
    </>
  );
};

export default SharedMockupEditor;
